import React from 'react';
import { SPACING, TYPOGRAPHY } from '../../theme';

export const getMapStyles = (colors: any, isDark: boolean): { [key: string]: React.CSSProperties } => ({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    touchAction: 'none',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1,
  },
  filtersOverlay: {
    position: 'fixed',
    bottom: '10%',
    left: 16,
    right: 16,
    maxWidth: '800px',
    margin: '0 auto',
    zIndex: 1000,
    backgroundColor: isDark ? 'rgba(31, 41, 55, 0.95)' : 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    borderRadius: '12px',
    padding: SPACING.xs,
    boxShadow: isDark ? '0 8px 32px rgba(0,0,0,0.5)' : '0 8px 32px rgba(0,0,0,0.25)',
  },
  filterRow: {
    display: 'flex',
    gap: SPACING.xs,
    marginBottom: SPACING.xs,
    overflowX: 'auto',
    overflowY: 'hidden',
    scrollbarWidth: 'thin',
    WebkitOverflowScrolling: 'touch',
  },
  dhsToggleButton: {
    padding: `${SPACING.sm} ${SPACING.md}`,
    fontSize: TYPOGRAPHY.fontSize.sm,
    fontWeight: TYPOGRAPHY.fontWeight.semibold,
    color: colors.textInverse,
    backgroundColor: colors.accentWarning,
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  filterButton: {
    padding: `${SPACING.sm} ${SPACING.md}`,
    fontSize: TYPOGRAPHY.fontSize.sm,
    fontWeight: TYPOGRAPHY.fontWeight.medium,
    color: colors.text,
    backgroundColor: colors.surface,
    border: `2px solid ${colors.border}`,
    borderRadius: '8px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  filterButtonActive: {
    backgroundColor: colors.accent,
    color: colors.textInverse,
    borderColor: colors.accent,
  },
  categoryFiltersScroll: {
    display: 'flex',
    gap: SPACING.xs,
    overflowX: 'auto',
    overflowY: 'hidden',
    paddingBottom: SPACING.xs,
    scrollbarWidth: 'thin',
    WebkitOverflowScrolling: 'touch',
  },
  categoryButton: {
    padding: `${SPACING.sm} ${SPACING.md}`,
    fontSize: TYPOGRAPHY.fontSize.sm,
    fontWeight: TYPOGRAPHY.fontWeight.medium,
    color: colors.text,
    backgroundColor: colors.surface,
    border: `2px solid ${colors.border}`,
    borderRadius: '8px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  centerButton: {
    padding: `${SPACING.sm} ${SPACING.md}`,
    fontSize: '20px',
    fontWeight: TYPOGRAPHY.fontWeight.medium,
    color: colors.text,
    backgroundColor: colors.surface,
    border: `2px solid ${colors.border}`,
    borderRadius: '8px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  mapContainer: {
    flex: 1,
    position: 'relative',
  },
  loadingOverlay: {
    position: 'absolute',
    top: '80px',
    right: '20px',
    backgroundColor: isDark ? 'rgba(31, 41, 55, 0.95)' : 'rgba(255, 255, 255, 0.95)',
    padding: '10px 16px',
    borderRadius: '8px',
    boxShadow: isDark ? '0 2px 8px rgba(0,0,0,0.4)' : '0 2px 8px rgba(0,0,0,0.15)',
    zIndex: 1000,
    fontSize: '14px',
    fontWeight: 500,
    color: colors.text,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  networkErrorBanner: {
    position: 'fixed',
    top: '10px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 2001,
    maxWidth: '600px',
    width: 'calc(100% - 32px)',
    animation: 'slideDown 0.3s ease-out',
  },
  networkErrorContent: {
    backgroundColor: '#DC2626',
    color: '#FFFFFF',
    padding: '12px 16px',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
  },
  networkErrorIcon: {
    fontSize: '20px',
    flexShrink: 0,
  },
  networkErrorText: {
    flex: 1,
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '1.4',
  },
  retryButton: {
    backgroundColor: '#FFFFFF',
    color: '#DC2626',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s',
    flexShrink: 0,
  },
});
